import { render, staticRenderFns } from "./EditTukuData.vue?vue&type=template&id=46d46370&scoped=true&"
import script from "./EditTukuData.vue?vue&type=script&lang=js&"
export * from "./EditTukuData.vue?vue&type=script&lang=js&"
import style0 from "./EditTukuData.vue?vue&type=style&index=0&id=46d46370&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d46370",
  null
  
)

export default component.exports